import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { FormContextProvider } from 'context/FormProvider'
import GoogleAnalyticsWrapper from 'context/GoogleAnalyticsProvider'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import 'tw-elements'
import App from './App'
import './index.css'
import reportWebVitals from './reportWebVitals'

const gtmParams = { id: 'GTM-5FLV9WX' }
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GoogleAnalyticsWrapper>
        <GTMProvider state={gtmParams}>
          <FormContextProvider>
            <App />
          </FormContextProvider>
        </GTMProvider>
      </GoogleAnalyticsWrapper>
    </BrowserRouter>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
